import 'livewire-sortable';
import $t from './lang';
import './loader';

import collapse from '@alpinejs/collapse';
import './alpine/chip-textarea';
document.addEventListener('alpine:init', () => {
  window.Alpine.plugin(collapse);

  window.Alpine.store('pdfViewer', {
    url: null,
    page: null,
    open(url, page = null) {
      this.url = url;
      this.page = page;
      window.Flux.modal('pdf-viewer').show();
      window.dispatchEvent(new CustomEvent('pdf-viewer-reset-drag'));
    },
    close() {
      this.url = null;
      this.page = null;
    },
    fullUrl() {
      if (!this.url) return '';
      const params = ['view=FitH'];
      if (this.page) params.push('page=' + this.page);
      return this.url + '#' + params.join('&');
    },
  });
});

window.$t = $t;

window.copyToClipboard = (e) => {
  const clipboardText = e.target.dataset.clipboardText || e.target.parentElement.dataset.clipboardText;
  const successMessage = e.target.dataset.successMessage || e.target.parentElement.dataset.successMessage;
  navigator.clipboard.writeText(clipboardText);
  new window.FilamentNotification()
    .success()
    .body(successMessage || $t('shared.copied_text_to_clipboard', { text: clipboardText }))
    .send();
};

document.addEventListener('livewire:init', () => {
  window.Livewire.on('openInNewTab', (args) => {
    window.open(args[0].url, '_blank');
  });
});
